<template>
    <el-dialog width="852px"
               :visible.sync="isShow"
               :title="`${isEditMode ? '修改' : '新增'}命令`"
               top="82px"
               append-to-body
               :close-on-click-modal="false">
        <el-form :model="formData" label-width="100px" ref="form">
            <el-form-item label="命令名称" prop="name" :rules="[{required: true, message: '请输入命令名称', trigger: 'blur'}, {validator: formatCommandName, trigger: 'blur'}]">
                <el-input :style="{width: '336px'}" v-model="formData.name" placeholder="请输入命令名称"
                          maxlength="50" @focus="showTip = true" @blur="showTip = false"
                ></el-input>
                <p :style="{fontSize: '12px', color: '#999999', lineHeight: '24px'}" v-if="showTip">输入值小于50位，只允许字母、数字、下划线的字符组合；输入以字母开头</p>
            </el-form-item>
            <el-form-item label="下发参数">
                <el-button size="small" @click="addInputParam">新增输入参数</el-button>
                <el-table :style="{width: '100%', marginBottom: '24px'}" :data="formData.inputParameters">
                    <el-table-column label="参数名称" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span class="ellipsis">{{scope.row.name || '-'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="类型参数" show-overflow-tooltip width="139">
                        <template slot-scope="scope">
                            <span class="ellipsis">{{scope.row.propertyType  | parsePropertyType}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否必选" show-overflow-tooltip width="119">
                        <template slot-scope="scope">
                            <span class="ellipsis">{{scope.row.isRequired.toString()}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="220">
                        <template v-slot="{row}">
                            <el-button type="text" @click="editInputParam(row)">修改</el-button>
                            <el-button type="text" @click="removeInputParam(row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item label="响应参数">
                <el-button size="small" @click="addResponseParam">新增响应参数</el-button>
                <el-table :style="{width: '100%', marginBottom: '24px'}" :data="formData.outputParameters">
                    <el-table-column label="参数名称" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span class="ellipsis">{{scope.row.name || '-'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="类型参数" show-overflow-tooltip width="139">
                        <template slot-scope="scope">
                            <span class="ellipsis">{{scope.row.propertyType | parsePropertyType}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否必选" show-overflow-tooltip width="119">
                        <template slot-scope="scope">
                            <span class="ellipsis">{{scope.row.isRequired.toString()}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="220">
                        <template v-slot="{row}">
                            <el-button type="text" @click="editOutputParam(row)">修改</el-button>
                            <el-button type="text" @click="removeOutputParam(row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
        </el-form>

        <div class="btns">
            <el-button plain size="small" @click="cancel">取消</el-button>
            <el-button type="primary" size="small" @click="confirm" :style="{marginLeft: '24px'}">确定</el-button>
        </div>
        <edit-param-dialog ref="editParamDialog"/>
    </el-dialog>
</template>

<script>
    import editParamDialog from "./editParamDialog";
    import {isServiceId, isServiceId2} from "../../assets/js/utils";
    export default {
        name: "addCommandDialog",
        components: {
            editParamDialog
        },
        data() {
            return {
                isShow: false,
                resolve: null,
                isEditMode: false,
                showTip: false,
                formData: {
                    name: '',
                    inputParameters: [],
                    outputParameters: [],
                },

            }
        },
        watch: {
            isShow(v) {
                if (!v) {
                    this.resolve && this.resolve(null)
                    this.resolve = null
                    this.$refs.form.clearValidate();
                }
            }
        },
        methods: {
            formatCommandName(rule, value, callback) {
                if (!isServiceId2(value)) {
                    callback(new Error('命令名称必须以字母开头'))
                    return
                }
                if (!isServiceId(value)) {
                    callback(new Error('命令名称只允许字母、数字、下划线、连字符的字符组合'))
                    return
                }
                if (this.names.includes(value)) {
                    callback(new Error('命令名称重复'))
                    return
                }
                callback()
            },
            initData() {
                this.showTip = false;
                this.formData = {
                    name: '',
                    inputParameters: [],
                    outputParameters: [],
                }
            },
            async show(data, names = []) {
                this.names = names;
                this.isEditMode = data && data.id;
                this.initData();
                if (data) {
                    this.formData = data;
                }
                this.isShow = true;
                return new Promise( resolve => {
                    this.resolve = resolve;
                    })
            },
            async addInputParam() {
                let res = await this.$refs.editParamDialog.show(undefined, this.formData.inputParameters && this.formData.inputParameters.map(item => item.name) || []);
                if (res === null) {
                    return;
                }
                this.formData.inputParameters.push(res);
            },
            async addResponseParam() {
                let res = await this.$refs.editParamDialog.show(undefined, this.formData.outputParameters&&this.formData.outputParameters.map(item => item.name) || []);
                if (res === null) {
                    return;
                }

                this.formData.outputParameters.push(res);
            },
            cancel() {
                this.resolve && this.resolve(null);
                this.resolve = null;
                this.isShow = false;
            },
            async confirm() {
                await this.$refs.form.validate();
                this.resolve && this.resolve(this.formData);
                this.isShow = false;
            },
            async editInputParam(data) {
                let res = await this.$refs.editParamDialog.show(Object.assign({}, data), this.formData.inputParameters&&this.formData.inputParameters.filter(item => item.name !== data.name).map(item => item.name) || []);
                if (res === null) {
                    return;
                }
                let index = this.formData.inputParameters.indexOf(data);
                if (index === -1) {
                    return
                }
                this.$set(this.formData.inputParameters, index, res);
            },
            removeInputParam(data) {
                this.$confirm(`是否删除名为${data.name}的参数？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    closeOnClickModal:false
                }).then(async () => {
                    let index = this.formData.inputParameters.indexOf(data);
                    if (index === -1) {
                        return
                    }
                    this.formData.inputParameters.splice(index, 1);
                }).catch(err=>{})
            },
            async editOutputParam(data) {
                let res = await this.$refs.editParamDialog.show(Object.assign({}, data), this.formData.outputParameters&&this.formData.outputParameters.filter(item => item.name !== data.name).map(item => item.name)||[]);
                if (res === null) {
                    return;
                }
                let index = this.formData.outputParameters.indexOf(data);
                if (index === -1) {
                    return
                }
                this.$set(this.formData.outputParameters, index, res);
            },
            removeOutputParam(data) {
                this.$confirm(`是否删除名为${data.name}的参数？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    closeOnClickModal:false
                }).then(async () => {
                    let index = this.formData.outputParameters.indexOf(data);
                    if (index === -1) {
                        return
                    }
                    this.formData.outputParameters.splice(index, 1);
                }).catch(err=>{})
            },
        },
    }
</script>

<style scoped>
    .btns{
        text-align: center;
        padding-top: 15px;
    }
    .el-table{
    border-left: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
}
</style>